export default __webpack_public_path__ + "static/media/save.b2dd6d76.svg";